"use client";

import { Icon } from "@commerce-frontend/ui/base/Icon/Icon";
import { Link } from "@commerce-frontend/ui/base/Link/Link";
import { Skeleton } from "@commerce-frontend/ui/base/Skeleton/Skeleton";
import { useWindowWidth } from "@commerce-frontend/ui/hooks/responsive";
import Image from "next/image";
import { useEffect, useState } from "react";
import type { Promotion } from "~/providers/PromotionProvider";

type Props = {
	promotion: Promotion;
};

export const PromotionTopBarContent = ({ promotion }: Props) => {
	const { windowWidth, isLoading } = useWindowWidth();
	const [isMobile, setIsMobile] = useState<boolean | null>(null);

	useEffect(() => {
		if (!isLoading) {
			setIsMobile(windowWidth.upToMobile);
		}
	}, [windowWidth, isLoading]);

	if (isLoading || isMobile === null) {
		return (
			<Skeleton className="col-main flex w-full items-center justify-center bg-transparent">
				<Icon icon="progress" className="size-8 animate-spin text-white" />
			</Skeleton>
		);
	}

	const {
		theme: promotionTheme,
		text: promotionText,
		link: promotionLink,
		linkText: promotionLinkText,
		mobileLinkText: promotionMobileLinkText,
	} = promotion;

	return (
		<div className="col-main flex items-center justify-between gap-2 sm:justify-center">
			<div className="flex items-center gap-1 border-r-2 border-r-black pr-2">
				{promotionTheme === "blacknovember" && (
					<div className="mt-0.5">
						<Image
							src="/assets/promotions/black-november.svg"
							alt="black november"
							width="132"
							height="20"
							unoptimized
						/>
					</div>
				)}
				{promotionTheme === "toolfest" && (
					<Image
						src="/assets/promotions/toolfest.svg"
						alt="toolfest"
						width="114"
						height="20"
						unoptimized
					/>
				)}
				{!isMobile && promotionText}
			</div>
			{promotionLink && promotionLinkText && (
				<Link
					className="text-sm underline md:text-base"
					href={promotionLink.url}
				>
					{isMobile && promotionMobileLinkText
						? promotionMobileLinkText
						: promotionLinkText}
				</Link>
			)}
		</div>
	);
};
